// LoginService.js
import axios from "axios";

const api = axios.create({
  baseURL: "https://didamax.net/api",
  params: { api_password: "EcommercApp@2026_$" },
  headers: { Accept: "application/json" },
});

// ✅ DEBUG: اطبع كل Request قبل ما يتبعت
api.interceptors.request.use((config) => {

  return config;
});

export default api;
